/* Product limits apply across variants and separate cart lines. Amounts are cents. */
(function (root) {
  'use strict';
  function maxForPrice(price) {
    return Number.isSafeInteger(price) && price > 0 ? Math.max(3, Math.floor(3499 / price)) : 3;
  }
  function group(items, productId) {
    return items.filter(function (item) { return String(item.product_id) === String(productId); });
  }
  function allowed(items) {
    var count = 0, subtotal = 0;
    items.forEach(function (item) {
      count += item.quantity;
      subtotal += item.quantity * item.original_price;
    });
    return count <= 3 || subtotal < 3500;
  }
  function remaining(items, productId, price) {
    var count = 0, subtotal = 0;
    group(items, productId).forEach(function (item) {
      count += item.quantity;
      subtotal += item.quantity * item.original_price;
    });
    return Math.max(0, 3 - count, price > 0 ? Math.floor((3499 - subtotal) / price) : 0);
  }
  var api = { maxForPrice: maxForPrice, allowed: allowed, remaining: remaining };
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root.document) return;
  root.ShipabobQuantityLimits = api;
  var doc = root.document, busy = new WeakSet(), approved = new WeakSet();
  var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  function message(form, text) {
    var el = form.querySelector('[data-quantity-message]');
    if (!el) {
      el = doc.createElement('p');
      el.setAttribute('data-quantity-message', '');
      el.setAttribute('role', 'status');
      form.appendChild(el);
    }
    el.textContent = text;
  }
  function priceFor(form) { return Number(form.getAttribute('data-unit-price')); }
  function syncProduct(form) {
    var input = form.querySelector('[name="quantity"]'), price = priceFor(form);
    if (input) {
      input.max = maxForPrice(price);
      if (+input.value > +input.max) input.value = input.max;
    }
    var note = form.querySelector('[data-quantity-limit-note]');
    if (note) note.textContent = 'Limit ' + maxForPrice(price) + ' per order. Sizes and packs of this product share the limit.';
  }
  doc.querySelectorAll('form[data-product-limit-id]').forEach(syncProduct);
  doc.addEventListener('shipabob:variant-change', function (event) {
    var form = doc.querySelector('[data-product-form]');
    if (form && event.detail) {
      form.setAttribute('data-unit-price', event.detail.price_cents);
      syncProduct(form);
    }
  });
  doc.addEventListener('change', function (event) {
    var input = event.target;
    if (input.matches('form[data-product-limit-id] [name="quantity"]')) {
      input.value = Math.max(1, Math.min(maxForPrice(priceFor(input.form)), Math.floor(+input.value) || 1));
    }
  });
  function invalidProduct(items) {
    return items.find(function (item) { return !allowed(group(items, item.product_id)); });
  }
  doc.addEventListener('submit', async function (event) {
    var form = event.target;
    if (approved.has(form)) { approved.delete(form); return; }
    var adding = form.hasAttribute('data-product-limit-id');
    var checkingOut = form.hasAttribute('data-cart-quantity-limits') && event.submitter && event.submitter.name === 'checkout';
    if (!adding && !checkingOut) return;
    event.preventDefault();
    if (busy.has(form)) return;
    busy.add(form);
    var submitter = event.submitter;
    try {
      var response = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw Error('Unable to check cart');
      var cart = await response.json(), items = cart.items;
      if (adding) {
        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput ? +quantityInput.value : 1;
        var available = remaining(items, form.getAttribute('data-product-limit-id'), priceFor(form));
        if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > available) {
          message(form, available ? 'You can add up to ' + available + ' more of this product. Sizes and packs share one limit.' : 'This product has reached its order limit. You can adjust it in your cart.');
          return;
        }
      } else {
        var inputs = Array.prototype.slice.call(form.querySelectorAll('[name="updates[]"]'));
        if (inputs.length !== items.length || items.some(function (item) { return !inputs.some(function (input) { return input.getAttribute('data-cart-line-key') === item.key; }); })) {
          message(form, 'Your cart changed. Please reload this page before checking out.'); return;
        }
        var projected = items.map(function (item) {
          var input = inputs.find(function (input) { return input.getAttribute('data-cart-line-key') === item.key; });
          return Object.assign({}, item, { quantity: Number(input.value) });
        });
        if (projected.some(function (item) { return !Number.isSafeInteger(item.quantity) || item.quantity < 0; })) {
          message(form, 'Enter a whole-number quantity of zero or more.'); return;
        }
        var invalid = invalidProduct(projected);
        if (invalid) {
          message(form, 'Please reduce ' + invalid.product_title + ': limit 3, or more when the combined product subtotal is below $35. Sizes and packs share the limit.');
          return;
        }
      }
      message(form, '');
      if (!form.reportValidity()) return;
      approved.add(form);
      form.requestSubmit(submitter || undefined);
    } catch (error) {
      message(form, 'We could not check the order limit. Please try again.');
    } finally { busy.delete(form); }
  }, true);
})(typeof window === 'object' ? window : globalThis);
